import React from 'react';
import pt from 'prop-types';
import { Box, Stack, Typography } from '@metarouter-private/mr-mui';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import { default as RoleIcon } from './RoleIcon';

const READ_EVENTS_ROLE_NAME = 'Read Events';

export default function RoleList({ roles }) {
  const { eventDebuggerEcmEnabled } = useFeatureEnabled(FEATURE_FLAGS.eventDebuggerEcm);

  /**
   * Dev Note | SP | 12/10/2025 | We filter out the Read Events documentation if an org has opted out of the feature altogether
   *  At the moment, the most static piece of data we have across environments is the role name
   *  If the role name changes in the future we'll need to ensure this is updated accordingly
   */
  const roleList = eventDebuggerEcmEnabled
    ? roles
    : roles.filter(role => role.name.toLowerCase() !== READ_EVENTS_ROLE_NAME.toLowerCase());

  return roleList.map(role => {
    return (
      <Box key={role.id}>
        <Stack direction="row" spacing={2}>
          <RoleIcon roleName={role.name} />
          <Typography variant="body2">{`${role.name} - ${role.description}`}</Typography>
        </Stack>
        <br />
      </Box>
    );
  });
}

RoleList.propTypes = {
  roles: pt.arrayOf(
    pt.shape({
      id: pt.string.isRequired,
      name: pt.string.isRequired,
      description: pt.string.isRequired,
    })
  ).isRequired,
};
